module.exports = __webpack_public_path__ + "static/media/Alegreya-SemiBold.e2d819db.ttf";